export default "__VITE_ASSET__CRYenQuz__"